import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { IconButton } from '../icon-button/icon-button';
import { Badge } from '../badge/badge';

/**
 * NotificationsButton — the bell in the top status bar. Shows a red badge (dot
 * or count) when there is something unread, overlapping the bell's top-right
 * (DS offset: left 16, top -8). Inherits `currentColor`, so it reads white on
 * the dark toolbar. Ported from the design system.
 */
@Component({
  selector: 'app-notifications-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, IconButton, Badge],
  template: `
    <span class="relative inline-flex" *transloco="let t">
      <app-icon-button
        icon="icon-notifications"
        [label]="t('statusToolbar.notifications')"
        (activated)="activated.emit()"
      />
      @if (show()) {
        <app-badge class="absolute -top-2 left-4" color="red" [count]="count()" />
      }
    </span>
  `,
})
export class NotificationsButton {
  readonly unread = input(false);
  readonly count = input<number | null>(null);

  readonly activated = output<void>();

  protected readonly show = computed(
    () => this.unread() || this.count() != null,
  );
}
